import { handleResponseError } from '@/Helpers.js';
import axios from '@/plugins/axios.js';

export default {
    state: {
        meetings: {},
    },

    actions: {
        async fetchCommentCounts(context, meetingId) {
            try {
                const { data } = await axios.get(`/api/meetings/${meetingId}/participant-comment-counts`, {
                    errorHandle: false,
                });

                context.commit('SET_CURRENT', {
                    meetingId,
                    counts: data.data,
                });

                return data.data;
            } catch (error) {
                handleResponseError(error);
            }
        },
    },

    mutations: {
        SET_CURRENT(state, { meetingId, counts }) {
            state.meetings[meetingId] = counts;
        },

        INCREMENT_COUNT(state, { meetingId, container, key }) {
            const current = state.meetings[meetingId][container][key] || 0;

            state.meetings[meetingId][container][key] = current + 1;
        },

        DECREMENT_COUNT(state, { meetingId, container, key }) {
            const current = state.meetings[meetingId][container][key] || 1;

            state.meetings[meetingId][container][key] = current - 1;
        },
    },
};
